import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import Img from 'gatsby-image'
import { FormattedMessage } from 'react-intl'
import { useMediaQuery } from '@gymondo/frontend-core/hooks'
import { mediaXsOnly } from '@gymondo/frontend-core/style-vars'
import { AppDownloadButtonGroup } from '@gymondo/frontend-core/components'
import { Cta } from '../../../../../component'
import style from './info-card.module.scss'

const InfoCard = ({
    className,
    imgClassName,
    title,
    subtitle,
    reverse,
    reverseMobile,
    hideImageOnMobile,
    zoomImageOnMobile,
    hasCta,
    hasDownloadGroup,
    displayCtaXS,
    children,
    ...rest
}) => {
    const matches = useMediaQuery(mediaXsOnly)
    const shouldHideImage = matches && hideImageOnMobile

    return (
        <div
            className={cn(
                reverse && style.reverse,
                style.wrapper,
                reverseMobile && style.reverseMobile,
                style[className]
            )}
        >
            {!shouldHideImage && (
                <Img
                    {...rest}
                    className={cn(
                        style.cardImage,
                        zoomImageOnMobile && style.zoomOnMobile,
                        imgClassName
                    )}
                />
            )}
            <div className={style.content}>
                {title && (
                    <h4 className={style.title}>
                        <FormattedMessage id={title} />
                    </h4>
                )}
                {subtitle && (
                    <div className={style.subtitle}>
                        <FormattedMessage id={subtitle} />
                    </div>
                )}
                {children}
                {hasCta && (
                    <Cta className={style.cta} displayXS={displayCtaXS} />
                )}
                {hasDownloadGroup && (
                    <AppDownloadButtonGroup className={style.apps} alwaysShow />
                )}
            </div>
        </div>
    )
}

InfoCard.propTypes = {
    className: PropTypes.string,
    imgClassName: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    reverse: PropTypes.bool,
    reverseMobile: PropTypes.bool,
    hideImageOnMobile: PropTypes.bool,
    zoomImageOnMobile: PropTypes.bool,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]),
    hasCta: PropTypes.bool,
    hasDownloadGroup: PropTypes.bool,
    displayCtaXS: PropTypes.bool,
}

InfoCard.defaultProps = {
    className: null,
    imgClassName: null,
    title: null,
    subtitle: null,
    reverse: false,
    reverseMobile: false,
    hideImageOnMobile: false,
    zoomImageOnMobile: true,
    children: null,
    hasCta: false,
    hasDownloadGroup: false,
    displayCtaXS: false,
}

export default InfoCard
